import React, { Component } from 'react';
import ClassicText from './ClassicText';
import Selector from './Selector';

const Classic = (props) => {
    return (
        <div className='classic'>
            <Selector classic={props.classic} onSelectorChangeNow={props.onSelectorChange} />
            <ClassicText classictext={props.classictext} />
        </div>
    );
}

export default Classic


// WEBPACK FOOTER //
// ./src/components/Classic.js